import React from 'react';
import styled from 'styled-components';

const LogoWrapper = styled.div`
  width: 100%;
  font-size: 32px;
`;

const LogoImage = styled.img`
  max-height: 80px;
  width: 100%;
  margin: 10px auto 0;
`;

export function companyLogoUrl(id) {
  switch (id) {
    case 1:
      return (
        <LogoImage
          alt="icon"
          src="swarco-logo.png"
        />
      );
    case 2:
      return (
        <LogoImage
          alt="icon"
          src="fpz.png"
        />
      );
    case 4:
      return (
        <LogoImage
          alt="icon"
          src="HC.png"
        />
      );
    case 5:
      return (
        <LogoImage
          alt="icon"
          src="smartview.png"
        />
      );
    case 6:
      return (
        <LogoImage
          alt="icon"
          src="AZM.png"
        />
      );
    case 7:
      return (
        <LogoImage
          alt="icon"
          src="HAC.png"
        />
      );
    default:
      return (
        <LogoWrapper>
          Retroflection
        </LogoWrapper>
      );
  }
}



// WEBPACK FOOTER //
// ./src/services/companyLogoUrl.js